import { useCallback, useEffect, useState } from "react";
import {
  listRecipients,
  type RecipientBookEntry,
} from "../api/recipients";
import { useSessionStore } from "../store/useSessionStore";

export interface UseRecipientsState {
  recipients: RecipientBookEntry[];
  loading: boolean;
  refresh: () => void;
}

/**
 * Loads the user's recipient book for the claimed link.
 * Failures resolve to an empty list so free-text entry still works.
 */
export const useRecipients = (limit = 10): UseRecipientsState => {
  const linkId = useSessionStore((s) => s.session.data?.linkId ?? null);

  const [recipients, setRecipients] = useState<RecipientBookEntry[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    if (!linkId) {
      setRecipients([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    listRecipients(linkId, limit)
      .then((result) => setRecipients(result))
      .finally(() => setLoading(false));
  }, [linkId, limit]);

  useEffect(() => {
    load();
  }, [load]);

  return { recipients, loading, refresh: load };
};
